'use strict';

bbw.directive.bbwPostEditor = ['bbw.LayoutTypeSvc', '$rootScope', function(bbwLayoutTypeSvc, $rootScope) {
    return {
        scope: {
            'postEditor': '=bbwPostEditor',
            'submitModifier': '@',
            'save': '&',
            'placeholder': '@',
            'withTitle': '=',
            'titlePlaceholder': '@',
            'areaPicker': '=',
            'areaAdminOnly': '=',
            'areaPickerPlaceholder': '@'
        },
        transclude: true,
        templateUrl: bbw.templateUrl('post-editor.html'),
        link: function(scope, element) {
            var editor = scope.postEditor;
            if (angular.isUndefined(editor) || !(editor instanceof bbw.service.PostEditor)) {
                throw new Error('bbw.service.PostEditor required');
            }
            if (angular.isUndefined(scope.submitModifier)) {
                scope.submitModifier = 'ctrl';
            }
            editor.setSubmitter(function(value) {
                return scope.messageEditor.send(value);
            });
            scope.hasTouch = bbwLayoutTypeSvc.hasTouch();
            var updateEntityScope = function() {
                scope.entityData = editor.entity ? editor.entity._data : undefined;
                editor.entity && editor.entity.photos._wireScope(null, scope, 'photos');
            };
            updateEntityScope();
            scope.$watch('postEditor.hidden', function(newValue, oldValue) {
                if (!newValue && oldValue) {
                    element[0].scrollIntoViewIfNeeded();
                }
            });
            scope.$watch('postEditor.entity', function(newValue, oldValue) {
                if (newValue !== oldValue) {
                    updateEntityScope();
                }
            });
            scope.event = {
                focusInput: editor.getFocusEvent()
            };
            var focus = function(selector) {
                var elementToFocus = element[0].querySelector(selector);
                if (elementToFocus && angular.isFunction(elementToFocus.focus)) {
                    elementToFocus.focus();
                }
            };
            scope.$on(editor.getFocusEvent(), function() {
                if (!editor.hidden && !scope.hasTouch) {
                    element[0].scrollIntoViewIfNeeded(true);
                }
                setTimeout(function() {
                    if (scope.areaPicker && !editor.input.collection_identifier) {
                        focus('.area-selector');
                    } else if (scope.withTitle) {
                        focus('.title-input');
                    } else {
                        scope.messageEditor && scope.messageEditor.focus(true);
                    }
                }, 0);
            });
            scope.$on(editor.getEditEvent(), function(_, args) {
                args && args.fn && scope.messageEditor && scope.messageEditor.update(args.fn);
            });
            scope.$on(bbw.service.PostEditor.BLUR_EVENT, function() {
                scope.input.showTouchSmileys = false;
            });
            if (angular.isString(editor.input.collection_identifier)) {
                editor.input.collection_identifier = parseInt(editor.input.collection_identifier);
            }
            scope.input = {
                editorInput: editor.input,
                showTouchSmileys: false,
                isAdminOnlyArea: function() {
                    if (editor.isAllowedAsAdmin()) {
                        return false;
                    }
                    if (!scope.areaPicker) {
                        return false;
                    }
                    if (!editor.input.collection_identifier) {
                        return false;
                    }
                    if (!scope.areaAdminOnly || !angular.isArray(scope.areaAdminOnly)) {
                        return false;
                    }
                    return scope.areaAdminOnly.indexOf(editor.input.collection_identifier) >= 0;
                },
                submit: function(value) {
                    editor.setEditedContents(
                        value,
                        scope.withTitle ? editor.input.title : undefined,
                        scope.areaPicker ? editor.input.collection_identifier : undefined,
                        editor.input.as_admin
                    );
                    return scope.save().then(function() {
                        // hack to remove focus from editor
                        var focusElement = element[0].querySelector('[tabindex]');
                        if (focusElement) {
                            focusElement.focus();
                        }
                    });
                }
            };
            scope.toggleTouchSmileys = function(event) {
                scope.input.showTouchSmileys = !scope.input.showTouchSmileys;
                if (event) {
                    event.stopPropagation();
                    event.preventDefault();
                    return false;
                }
                return true;
            };
        }
    }

}];
